export default __webpack_public_path__ + "static/media/AIRFRANCE_4.c1739aaa.gif";